export enum ContentType {
  DEFAULT = 'application/json',
  SKD = 'application/allegion.keying.addsinglekeydifferentmaster+json',
  DIRECT_CHANGES = 'application/allegion.keying.adddirectmaster+json',
  CHANGE_KEYS = 'application/allegion.keying.addchangekeys+json',
  SLM = 'application/allegion.keying.addselectivemaster+json',
  CONSTRUCTION_KEYS = 'application/allegion.keying.addconstructionkey+json',
  CROSS_KEYS = 'application/allegion.keying.addcrosskey+json',
  CROSS_KEY_RANGE = 'application/allegion.keying.addbulkcrosskey+json',
  CONTROL_KEYS = 'application/allegion.keying.addcontrolkey+json',
  MASTER_KEYS = 'application/allegion.keying.addsubmasters+json',
  BUDGET = 'application/allegion.keying.masterkey.budget+json',
  MOVE_KEYS = 'application/allegion.keying.move.keys+json',
  RENAME_KEYS = 'application/allegion.keying.rename.keys+json',
  CHANGE_KEY_TYPE = 'application/allegion.keying.update.key.type+json',
}
